import { ROLE_LEVEL } from "../Constants/RolesConstants";
import { JWT_TOKEN } from "../Constants/StorageConstants";

export const getToken = () => localStorage.getItem(JWT_TOKEN);

export const getUserRoles = () => {
  const token = getToken();
  if (!token) return [];

  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    return payload.roles || [];
  } catch (error) {
    console.error("Invalid token:", error);
    return [];
  }
};

export const getHighestRole = () => {
  const roles = getUserRoles();
  let transientRoleLevel = 5;
  let finalRole = null;
  roles.forEach((role) => {
    if (ROLE_LEVEL[role] < transientRoleLevel) {
      transientRoleLevel = ROLE_LEVEL[role];
      finalRole = role;
    }
  });
  return finalRole;
};

export const getPermissions = () => {
  const token = getToken();
  if (!token) return [];

  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    return payload.permissions || [];
  } catch (error) {
    console.error("Invalid token:", error);
    return [];
  }
};

export const isAuthenticated = () => {
  const token = localStorage.getItem(JWT_TOKEN);
  if (!token) return false;
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    const currentTime = Math.floor(Date.now() / 1000);
    return payload.exp > currentTime;
  } catch (error) {
    return false;
  }
};

export const hasRole = (roleList) => {
  const token = getToken();
  if (!token) return false;

  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    const roles = payload.roles;
    return roles.some((role) => roleList.includes(role));
  } catch (error) {
    console.error("Invalid token:", error);
    return false;
  }
};

// export const canViewMenu = (screen) => {
//   const token = getToken();
//   if (!token) return [];

//   try {
//     const payload = JSON.parse(atob(token.split(".")[0]));

//     return roleList?.some(role => payload.permissions.includes(role));
//   } catch (error) {
//     console.error("Invalid token:", error);
//     return false;
//   }
// };
